import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Copy, Gift, Share2 } from "lucide-react";
import { toast } from "sonner";

export default function ReferralCard() {
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/learner/referral").then(r => setInfo(r.data)).catch(() => {}); }, []);
  if (!info) return null;

  const copy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Copied to clipboard");
  };

  return (
    <div className="border border-border bg-card p-6 relative overflow-hidden" data-testid="referral-card">
      <div className="absolute -right-6 -top-6 w-32 h-32 bg-primary/10 rounded-full" />
      <div className="relative">
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-primary">
          <Gift className="w-4 h-4" /> Refer & Earn
        </div>
        <div className="mt-2 font-display text-2xl font-semibold tracking-tight">
          Give ${info.bonus_amount}, get ${info.bonus_amount} per friend
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          Friends save ${info.bonus_amount} on their first lesson. You earn ${info.bonus_amount} in credit once they pay.
        </p>

        <div className="grid sm:grid-cols-2 gap-3 mt-5">
          <div>
            <div className="text-xs uppercase tracking-widest text-muted-foreground">Your code</div>
            <div className="mt-1 flex">
              <Input readOnly value={info.referral_code || ""} className="rounded-sm rounded-r-none font-mono tracking-widest text-base" data-testid="referral-code-value" />
              <Button type="button" variant="outline" className="rounded-sm rounded-l-none border-l-0" onClick={() => copy(info.referral_code)} data-testid="copy-code-btn">
                <Copy className="w-4 h-4" />
              </Button>
            </div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-muted-foreground">Share link</div>
            <div className="mt-1 flex">
              <Input readOnly value={info.share_link} className="rounded-sm rounded-r-none text-xs truncate" data-testid="share-link-value" />
              <Button type="button" className="rounded-sm rounded-l-none" onClick={() => copy(info.share_link)} data-testid="copy-link-btn">
                <Share2 className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-3 mt-5 pt-5 border-t border-border">
          <Stat l="Available credit" v={`$${(info.credits||0).toFixed(2)}`} testid="credits-balance" />
          <Stat l="Friends invited" v={info.invited_count} testid="invited-count" />
          <Stat l="Earned referrals" v={info.earned_referrals} testid="earned-referrals" />
        </div>
      </div>
    </div>
  );
}
function Stat({ l, v, testid }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-widest text-muted-foreground">{l}</div>
      <div className="font-display text-xl font-semibold mt-1" data-testid={testid}>{v}</div>
    </div>
  );
}
